export default __webpack_public_path__ + "static/media/Pcb.d878b9db.jpg";